import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Filter, { FilterModel } from '../../components/Filter/Filter';
import { upsertFilterToKey } from '../../services/filterService';

export class ServiceFilterFields extends FilterModel {
  constructor(data: any = {}) {
    super(data);
  }

  public get totalFilters(): number {
    return !this.q ? 0 : 1;
  }
}

interface ServicesFilterProps {
  onSubmit: (data: ServiceFilterFields) => void;
  filterFields: ServiceFilterFields;
}

export default function ServicesFilter({
  onSubmit,
  filterFields,
}: ServicesFilterProps) {
  const { register, handleSubmit, reset } = useForm<ServiceFilterFields>({
    mode: 'onBlur',
  });
  const pageKey = 'services';

  const [servicesLoading, setServicesLoading] = useState(false);

  const clear = () => {
    reset({
      q: null,
      skip: 0,
      take: 25,
    });
    upsertFilterToKey(pageKey, {});
  };

  useEffect(() => {
    reset(filterFields);
  }, [filterFields]);

  return (
    <Filter
      isLoading={servicesLoading}
      onSubmit={handleSubmit(onSubmit)}
      clear={clear}
      totalApplied={filterFields?.totalFilters || 0}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <input
            {...register('q')}
            className='form-control'
            placeholder='Digite para pesquisar'
            type='text'
          />
        </div>
      </form>
    </Filter>
  );
}
